import React from 'react';
import '../styles/Modal.css';

function ViewGLModal({ entity, glVersion, onClose }) {
  const formatTimestamp = (timestamp) => {
    if (!timestamp) return 'N/A';
    const match = timestamp.match(/(\d{4})(\d{2})(\d{2})_(\d{2})(\d{2})(\d{2})/);
    if (match) {
      const [, year, month, day, hour, minute, second] = match;
      return `${year}-${month}-${day} ${hour}:${minute}:${second}`;
    }
    return timestamp;
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>View GL Details</h2>
          <button className="modal-close" onClick={onClose}>&times;</button>
        </div>

        <div className="modal-body">
          <div className="info-box">
            <h3>General Ledger Information</h3>
            <div className="gl-details">
              <div className="detail-row">
                <strong>Entity:</strong>
                <span>{entity.name}</span>
              </div>
              <div className="detail-row">
                <strong>Period:</strong>
                <span>{glVersion.period || 'N/A'}</span>
              </div>
              <div className="detail-row">
                <strong>Timestamp:</strong>
                <span>{formatTimestamp(glVersion.timestamp)}</span>
              </div>
              <div className="detail-row">
                <strong>Total Entries:</strong>
                <span>{glVersion.record_count?.toLocaleString() || 'N/A'}</span>
              </div>
              <div className="detail-row">
                <strong>Unique Transactions:</strong>
                <span>{glVersion.unique_transactions?.toLocaleString() || 'N/A'}</span>
              </div>
              <div className="detail-row">
                <strong>Unique Accounts:</strong>
                <span>{glVersion.unique_accounts?.toLocaleString() || 'N/A'}</span>
              </div>
              {glVersion.start_date && (
                <div className="detail-row">
                  <strong>Start Date:</strong>
                  <span>{glVersion.start_date}</span>
                </div>
              )}
              {glVersion.end_date && (
                <div className="detail-row">
                  <strong>End Date:</strong>
                  <span>{glVersion.end_date}</span>
                </div>
              )}
              {glVersion.upload_time && (
                <div className="detail-row">
                  <strong>Upload Time:</strong>
                  <span>{glVersion.upload_time}</span>
                </div>
              )}
            </div>
          </div>

          <div className="alert alert-info">
            <p>To view the detailed GL data item-by-item, generate an RPT from this GL version and use the "View RPT Details" feature.</p>
          </div>
        </div>

        <div className="modal-footer">
          <button className="btn btn-secondary" onClick={onClose}>
            Close
          </button>
        </div>
      </div>
    </div>
  );
}

export default ViewGLModal;
